export const RECENT_SEARCHES_KEY = 'search:recent'
export const MAX_RECENT_SEARCHES = 8
